import { useQuery } from '@tanstack/react-query';

import { getPermissions, getRoles } from '../../../api/roles';
import { useAuth } from '../../auth/AuthProvider';

export function useRoles() {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['roles'],
    queryFn: () => getRoles(tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}

export function usePermissions() {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => getPermissions(tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}
